import React from 'react';

import { Button } from 'components/ui/button';

import {
  ABBREVIATIONS_V2_TEST_IDS,
  ABBREVIATIONS_V2_TEXTS} from '../AbbreviationsSettingsV2.consts';

interface IAbbreviationsErrorStateProps {
  onRetry: () => void;
}

export const AbbreviationsErrorState = ({
  onRetry
}: IAbbreviationsErrorStateProps): React.ReactElement => (
  <div
    className="flex flex-col items-center justify-center gap-4 rounded-lg border border-base-border bg-white p-9"
    data-testid={ABBREVIATIONS_V2_TEST_IDS.error}
  >
    <p className="text-base font-normal text-base-mutedForeground">
      {ABBREVIATIONS_V2_TEXTS.LOAD_ERROR}
    </p>
    <Button
      variant="outline"
      onClick={onRetry}
      className="border-base-border text-base-foreground"
      data-testid={ABBREVIATIONS_V2_TEST_IDS.retry}
    >
      {ABBREVIATIONS_V2_TEXTS.RETRY}
    </Button>
  </div>
);
